export enum ListItemFieldListType {
  LocalListDataFilterEnabled,
  LookupFilterEnabled
}